(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bw-wishlist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bw-wishlist')) {
    class BwWishlist extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.initialized = true;
        this.key = 'binnenweelde.wishlist.v1';
        this.rootPath = this.dataset.root.replace(/\/?$/, '/');
        this.items = this.read();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        document.addEventListener('click', (event) => this.handleClick(event), { ...options, capture: true });
        window.addEventListener('storage', (event) => {
          if (event.key !== this.key && event.key !== null) return;
          this.items = this.read();
          this.sync();
          if (this.dialog.open) this.render();
        }, options);
        window.addEventListener('pageshow', () => {
          this.items = this.read();
          this.sync();
        }, options);
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('bw-wishlist-open');
          this.sync();
          if (this.opener?.isConnected) this.opener.focus();
        }, options);
        this.observer = new MutationObserver((records) => {
          const hasNewButtons = records.some((record) => Array.from(record.addedNodes).some((node) =>
            node.nodeType === 1 && (node.matches('.bw-wishlist-button') || node.querySelector('.bw-wishlist-button'))
          ));
          if (hasNewButtons) this.sync();
        });
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.sync();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        clearTimeout(this.announcementTimer);
        document.documentElement.classList.remove('bw-wishlist-open');
        this.initialized = false;
      }

      read() {
        if (this.storageFailed && this.items) return this.items;
        try {
          const stored = JSON.parse(localStorage.getItem(this.key) || '[]');
          if (!Array.isArray(stored)) return [];
          const unique = new Map();
          stored.slice(0, 100).forEach((item) => {
            if (item && typeof item.handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(item.handle)) {
              unique.set(item.handle, {
                handle: item.handle,
                title: String(item.title || item.handle).slice(0, 500),
                image: this.safeImage(item.image),
                price: String(item.price || '').slice(0, 80),
                currency: String(item.currency || '').slice(0, 3),
                varies: item.varies === true
              });
            }
          });
          return Array.from(unique.values());
        } catch {
          return this.items || [];
        }
      }

      safeImage(value) {
        if (typeof value !== 'string' || !value) return '';
        try {
          const url = new URL(value, location.origin);
          if (url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com')) return url.href;
        } catch {}
        return '';
      }

      persist() {
        try {
          localStorage.setItem(this.key, JSON.stringify(this.items));
          this.storageFailed = false;
          return true;
        } catch {
          this.storageFailed = true;
          return false;
        }
      }

      announce(message) {
        const status = this.querySelector('[data-bw-wishlist-status]');
        clearTimeout(this.announcementTimer);
        status.textContent = message;
        this.announcementTimer = setTimeout(() => { status.textContent = ''; }, 3500);
      }

      sync() {
        const handles = new Set(this.items.map((item) => item.handle));
        document.querySelectorAll('[data-bw-wishlist-toggle]').forEach((button) => {
          const selected = handles.has(button.dataset.handle);
          button.hidden = false;
          button.setAttribute('aria-pressed', String(selected));
          button.setAttribute('aria-label', `${selected ? this.dataset.remove : this.dataset.add}: ${button.dataset.title}`);
          const label = button.querySelector('[data-bw-wishlist-label]');
          if (label) label.textContent = selected ? this.dataset.saved : this.dataset.add;
        });
        document.querySelectorAll('[data-bw-wishlist-open]').forEach((button) => {
          button.hidden = false;
          button.setAttribute('aria-expanded', String(this.dialog.open));
          button.setAttribute('aria-label', this.dataset.open + (this.items.length ? ` (${this.items.length})` : ''));
        });
        document.querySelectorAll('[data-bw-wishlist-count]').forEach((count) => {
          count.textContent = this.items.length ? String(this.items.length) : '';
          count.hidden = this.items.length === 0;
        });
      }

      handleClick(event) {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('[data-bw-wishlist-open], [data-bw-wishlist-toggle], [data-bw-wishlist-close], [data-bw-wishlist-remove]');
        if (!button) {
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        if (button.hasAttribute('data-bw-wishlist-close')) { this.dialog.close(); return; }
        if (button.hasAttribute('data-bw-wishlist-open')) { this.open(button); return; }
        this.items = this.read();
        const handle = button.dataset.handle;
        const index = this.items.findIndex((item) => item.handle === handle);
        let message;
        if (index !== -1) {
          this.items.splice(index, 1);
          message = this.dataset.removed;
        } else if (button.hasAttribute('data-bw-wishlist-toggle')) {
          if (this.items.length >= 100) { this.announce(this.dataset.limit); return; }
          this.items.unshift({ handle, title: button.dataset.title, image: this.safeImage(button.dataset.image), price: button.dataset.price, varies: button.dataset.priceVaries === 'true', currency: this.dataset.currency });
          message = this.dataset.added;
        } else { return; }
        const saved = this.persist();
        this.sync();
        if (this.dialog.open) {
          const wasRemove = button.hasAttribute('data-bw-wishlist-remove');
          this.render();
          if (wasRemove) {
            const remaining = this.querySelectorAll('[data-bw-wishlist-remove]');
            (remaining[Math.min(Math.max(index, 0), remaining.length - 1)] || this.querySelector('[data-bw-wishlist-close]')).focus();
          }
        }
        this.announce(saved ? message : this.dataset.storageError);
      }

      open(button) {
        this.items = this.read();
        this.opener = button;
        this.render();
        if (!this.dialog.open) this.dialog.showModal();
        document.documentElement.classList.add('bw-wishlist-open');
        this.sync();
        this.refresh();
      }

      render() {
        const list = this.querySelector('[data-bw-wishlist-list]');
        const template = this.querySelector('[data-bw-wishlist-row]');
        const fragment = document.createDocumentFragment();
        this.items.forEach((item) => {
          const row = template.content.firstElementChild.cloneNode(true);
          row.dataset.handle = item.handle;
          const url = `${this.rootPath}products/${encodeURIComponent(item.handle)}`;
          const link = row.querySelector('[data-bw-item-link]');
          link.href = url;
          link.textContent = item.title;
          row.querySelector('[data-bw-item-image-link]').href = url;
          const image = row.querySelector('[data-bw-item-image]');
          if (item.image) image.src = item.image;
          else image.hidden = true;
          row.querySelector('[data-bw-item-price]').textContent = item.currency === this.dataset.currency ? `${item.varies ? this.dataset.from + ' ' : ''}${item.price}` : '';
          const remove = row.querySelector('[data-bw-wishlist-remove]');
          remove.dataset.handle = item.handle;
          remove.setAttribute('aria-label', `${this.dataset.remove}: ${item.title}`);
          fragment.append(row);
        });
        list.replaceChildren(fragment);
        this.querySelector('[data-bw-wishlist-empty]').hidden = this.items.length > 0;
        this.querySelector('[data-bw-wishlist-total]').textContent = this.items.length ? `(${this.items.length})` : '';
        const warning = this.querySelector('[data-bw-wishlist-warning]');
        warning.hidden = !this.storageFailed;
        warning.textContent = this.storageFailed ? this.dataset.storageError : '';
      }

      async refresh() {
        const run = (this.refreshRun || 0) + 1;
        this.refreshRun = run;
        const queue = this.items.map((item) => item.handle);
        const worker = async () => {
          while (queue.length && this.isConnected && this.dialog.open && this.refreshRun === run) {
            const handle = queue.shift();
            try {
              const response = await fetch(`${this.rootPath}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin', signal: AbortSignal.timeout(8000) });
              if (this.refreshRun !== run) return;
              const row = Array.from(this.querySelectorAll('.bw-wishlist-item')).find((element) => element.dataset.handle === handle);
              if (!row) continue;
              if (response.status === 404) {
                const state = row.querySelector('[data-bw-item-state]');
                state.textContent = this.dataset.unavailable;
                state.hidden = false;
                row.querySelector('[data-bw-item-price]').textContent = '';
                continue;
              }
              if (!response.ok) continue;
              const product = await response.json();
              if (this.refreshRun !== run || !row.isConnected) continue;
              const item = this.items.find((entry) => entry.handle === handle);
              if (!item) continue;
              item.title = product.title || item.title;
              item.image = this.safeImage(product.featured_image) || item.image;
              item.varies = product.price_varies === true;
              if (typeof product.price === 'number') {
                item.price = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(product.price / 100);
                item.currency = this.dataset.currency;
              }
              row.querySelector('[data-bw-item-link]').textContent = item.title;
              row.querySelector('[data-bw-item-price]').textContent = `${item.varies ? this.dataset.from + ' ' : ''}${item.price}`;
              const image = row.querySelector('[data-bw-item-image]');
              if (item.image) { image.src = item.image; image.hidden = false; }
            } catch {}
          }
        };
        await Promise.all(Array.from({ length: Math.min(4, queue.length) }, worker));
      }
    }
    customElements.define('bw-wishlist', BwWishlist);
  }
  } catch(e) { console.error(e); }
})();

})();
